export const appCameraIcon = {
  data: `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
  <title>Camera</title>
  <path d="M26.667 7.867h-3.333c-1.067 0-2-0.4-2.667-1.2s-1.6-1.333-2.667-1.333h-4c-1.067 0-2 0.4-2.667 1.2s-1.6 1.2-2.667 1.2h-3.333c-2.267 0-4 1.733-4 4v10.933c0 2.267 1.733 4 4 4h21.333c2.267 0 4-1.733 4-4v-10.8c0-2.267-1.733-4-4-4zM16 22.667c-2.933 0-5.333-2.4-5.333-5.333s2.4-5.333 5.333-5.333 5.333 2.4 5.333 5.333-2.4 5.333-5.333 5.333z"></path>
  </svg>`,
  name: 'camera',
};
